export const EMPTY_TARGET_TEXT = "–";
export const WEEKDAY_SHORT = ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"];
export const PAST_DAY_TOOLTIP = "วันที่ผ่านไปแล้ว แก้ไม่ได้";
export const NO_PLAN_TOOLTIP = "ไม่มีแผนวิ่ง (กรอกได้)";
export const FILTER_MISSING_TEXT = "แสดงเฉพาะสายที่ยังไม่ครบ ›";
export const SHOW_ALL_TEXT = "แสดงทุกสาย";
